'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $('[data-carousel]', this).slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: true,
        infinity: false,
        lazyLoad: 'ondemand',
        prevArrow: '<button class="arrow arrow-left"><svg x="0" y="0" viewBox="49.7 30.6 32.8 96" enable-background="new 49.7 30.6 32.8 96" xml:space="preserve"><polygon class="arrow-polygon" points="82.6,126 50.6,78.6 82.5,31.1 81.7,30.6 49.7,78.6 81.7,126.6 "/></svg></button>',
        nextArrow: '<button class="arrow arrow-right"><svg x="0" y="0" viewBox="49.7 30.6 32.8 96" enable-background="new 49.7 30.6 32.8 96"><polygon class="arrow-polygon" points="49.7,31.1 81.7,78.6 49.8,126 50.6,126.6 82.6,78.6 50.6,30.6 "/></svg></button>',
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });

    // HP talk about
    var $hpTalkAboutCarousel = $('#hpTalkAbout', document);
    if ($hpTalkAboutCarousel.length && !$hpTalkAboutCarousel.hasClass('slick-initialized')) {
        var currentSlickBefore = 0;

        $hpTalkAboutCarousel.slick({
            adaptiveHeight: true,
            dots: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            appendArrows: $hpTalkAboutCarousel.closest('section').find('.h-t__arrows'),
            appendDots: $('.talk-about__wrap')
        });

        $hpTalkAboutCarousel.on('beforeChange', function (e, s, currentSlide) {
            currentSlickBefore = currentSlide;
        });

        // hide long text
        $hpTalkAboutCarousel.on('afterChange', function (e, s, currentSlide) {

            if (currentSlickBefore !== currentSlide) {
                $('.text-short', $hpTalkAboutCarousel).removeClass('hidden');
                $('.text-long', $hpTalkAboutCarousel).addClass('hidden');
                $('.show-more-text', $hpTalkAboutCarousel).show();
            }
        });
    }

    $('#product-top', this).slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        prevArrow: '<button class="product-top-btn product-top-btn--left"><svg x="0" y="0" viewBox="49.7 30.6 32.8 96" enable-background="new 49.7 30.6 32.8 96" xml:space="preserve"><polygon class="arrow-polygon" points="82.6,126 50.6,78.6 82.5,31.1 81.7,30.6 49.7,78.6 81.7,126.6 "/></svg></button>',
        nextArrow: '<button class="product-top-btn product-top-btn--right"><svg x="0" y="0" viewBox="49.7 30.6 32.8 96" enable-background="new 49.7 30.6 32.8 96"><polygon class="arrow-polygon" points="49.7,31.1 81.7,78.6 49.8,126 50.6,126.6 82.6,78.6 50.6,30.6 "/></svg></button>',
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
            }
        }]
    });

    var $seriesCarousel = $(".series__carousel", this);
    if ($seriesCarousel.length && !$seriesCarousel.hasClass("slick-initialized")) {
        var seriesInitClasses = function seriesInitClasses(elm) {
            $(elm).prev().addClass("series__item--prev");
            $(elm).addClass("series__item--current");
            $(elm).next().addClass("series__item--next");
        };

        $seriesCarousel.each(function () {
            var carousel = $(this);
            var itemLength = $(".series__item", carousel).length;
            var fistItemIndex = itemLength == 3 ? 2 : 1;

            //add fake items for rolling
            if (itemLength < 4) {
                carousel.append('<span class="series__item" />');
                carousel.prepend('<span class="series__item" />');
            }

            // init event must be before slick
            carousel.on("init", function (e, slick) {
                seriesInitClasses($(slick.$slides).get(fistItemIndex));
            });

            carousel.slick({
                initialSlide: fistItemIndex,
                infinite: false,
                draggable: false,
                adaptiveHeight: true,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                dots: false,
                centerMode: true,
                variableWidth: true,
                slidesToShow: 3,
                slidesToScroll: 1
            });

            // single item in series
            if (itemLength == 1) {
                $("a.series__item", carousel).removeClass("series__item--prev").addClass("series__item--current");
            }

            carousel.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                // prevent fast clicks
                $(".series__item", slick.$slider).removeClass("series__item--hide");

                // move to right
                if (currentSlide < nextSlide) {
                    $(".series__item--prev", slick.$slider).addClass("series__item--hide");
                } else {
                    // move to left
                    $(".series__item--next", slick.$slider).addClass("series__item--hide");
                }

                $(slick.$slides).removeClass("series__item--prev series__item--next series__item--current");
                seriesInitClasses(slick.$slides.get(nextSlide));

                if (itemLength < 4) {
                    // hide arrow before last item
                    if (nextSlide == itemLength) {
                        $(".arrow--right", carousel).hide();
                    } else {
                        $(".arrow--right", carousel).show();
                    }

                    // hide arrow for first item
                    if (nextSlide == 1) {
                        $(".arrow--left", carousel).hide();
                    } else {
                        $(".arrow--left", carousel).show();
                    }
                }
            });
        });
    }
};

var $ = require('jquery');

var prevArrow = '<button class="arrow arrow-left"><svg x="0" y="0" viewBox="49.7 30.6 32.8 96" enable-background="new 49.7 30.6 32.8 96" xml:space="preserve"><polygon class="arrow-polygon" points="82.6,126 50.6,78.6 82.5,31.1 81.7,30.6 49.7,78.6 81.7,126.6 "/></svg></button>';
var nextArrow = '<button class="arrow arrow-right"><svg x="0" y="0" viewBox="49.7 30.6 32.8 96" enable-background="new 49.7 30.6 32.8 96"><polygon class="arrow-polygon" points="49.7,31.1 81.7,78.6 49.8,126 50.6,126.6 82.6,78.6 50.6,30.6 "/></svg></button>';

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/carousels.js
// module id = 925
// module chunks = 0